import type { ComposeBodyDocument } from './types';

export function emptyComposeDoc(): ComposeBodyDocument {
  return { bodyKind: 'rich', userBody: '' };
}
